type ProductsLinks = {
  [key: string]: { app: string; marketing: string }
}

// TODO: Test while we wait for the new product links to be available
const productLinks: ProductsLinks = {
  agentbox: {
    app: 'https://app.sales.reapit.com.au',
    marketing: 'https://www.reapit.com/marketing',
  },
  bdm: {
    app: 'https://www.reapit.com',
    marketing: 'https://www.reapit.com/marketing',
  },
  consoleCloud: {
    app: 'https://www.reapit.com',
    marketing: 'https://www.reapit.com/marketing',
  },
  ireForms: {
    app: 'https://www.reapit.com',
    marketing: 'https://www.reapit.com/marketing',
  },
  ireWeb: {
    app: 'https://www.reapit.com',
    marketing: 'https://www.reapit.com/marketing',
  },
  keywhere: {
    app: 'https://www.reapit.com',
    marketing: 'https://www.reapit.com/marketing',
  },
  lettingsBDM: {
    app: 'https://www.reapit.com',
    marketing: 'https://www.reapit.com/marketing',
  },
  reapitForms: {
    app: 'https://www.reapit.com',
    marketing: 'https://www.reapit.com/marketing',
  },
  reapitProposals: {
    app: 'https://www.reapit.com',
    marketing: 'https://www.reapit.com/marketing',
  },
  reapitWebsites: {
    app: 'https://www.reapit.com',
    marketing: 'https://www.reapit.com/marketing',
  },
}

export function getProductLink(productId: string, isProductAccessible: boolean): string {
  const product = productLinks[productId]
  if (!product) {
    return ''
  }
  return isProductAccessible ? product.app : product.marketing
}
